export default {
  getAll: {
    method: 'post',
    url: '/company/salary-assumptions/list'
  },
  create: {
    method: 'post',
    url: '/company/salary-assumptions'
  },
  update: {
    method: 'put',
    url: '/company/salary-assumptions/update'
  },
  delete: {
    method: 'delete',
    url: '/company/salary-assumptions'
  }
}
